export const MynumberUrls = {
  Success: '/auth/success',
  Mynumber: '/auth/mynumber',
  Webview: '/auth/webview'
};
